var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ModalComponent_1;
import { html, nothing, css } from 'lit';
import { customElement, property, query, state } from 'lit/decorators.js';
import { Icon } from '../../utils/icon-utils.js';
import { GGOBaseComponent } from '../ggo.base.component.js';
import { Translate } from '../../utils/translate.js';
let ModalComponent = class ModalComponent extends GGOBaseComponent {
    constructor() {
        super(...arguments);
        this.isOpen = false;
        this.showValidateBtn = true;
        this.showAddBtn = false;
        this.showCancelBtn = true;
        this.showCloseBtn = false;
        this.autoClose = true;
        this.variant = 'default';
        this.modalTitle = '';
        this._addBtnEnabled = true;
        this._validateBtnEnabled = true;
        this.uniqueId = `${Math.random().toString(36).substr(2, 9)}`;
        this._onOutsideClick = (e) => {
            if (this.autoClose) {
                const container = this.shadowRoot?.querySelector('.slds-modal__container');
                if (!container)
                    return;
                const path = e.composedPath();
                if (!path.includes(container)) {
                    this.handleCancelAndClose();
                }
            }
        };
    }
    static { ModalComponent_1 = this; }
    static { this.ALERT = 'alert'; }
    static { this.SUCCESS = 'success'; }
    static { this.WARNING = 'warning'; }
    static get styles() {
        return [
            ...super.styles,
            css `
        @media (min-width: 1250px) {
          .slds-modal__container {
            // width: auto;
             max-width: 50%;
            // min-width: 40rem;
            display: inline-block;
            margin-left: auto;
            margin-right: auto;
            left: 0;
            right: 0;
            position: relative;
          }
        }
        @media (max-width: 1250px) {
          .slds-modal__container {
            max-width: 80%;
            width: auto;
            display: inline-block;
          }
        }
        .slds-modal__header {
          background-color: #f8f9fa;
          border-top-right-radius: 1rem;
          border-top-left-radius: 1rem;
          color: #080707;
        }
        .slds-modal__content {
          background-color: #f8f9fa;
        }
        .slds-modal__footer {
          background-color: #fff;
          border-bottom-right-radius: 1rem;
          border-bottom-left-radius: 1rem;
        }
        .slds-theme_alert-texture {
          background-image: linear-gradient(
            45deg,
            rgba(255, 150, 150, 0.3) 25%,
            transparent 25%,
            transparent 50%,
            rgba(255, 150, 150, 0.3) 50%,
            rgba(255, 150, 150, 0.3) 75%,
            transparent 75%,
            transparent
          );
        }
        .slds-modal.fade-out {
          opacity: 0;
          transition: opacity 0.6s;
        }
        .slds-modal {
          opacity: 1;
          transition: opacity 0.6s;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .slds-backdrop.fade-out {
          opacity: 0;
          transition: opacity 0.6s;
        }
        .slds-backdrop {
          opacity: 1;
          transition: opacity 0.6s;
        }
      `,
        ];
    }
    firstUpdated() {
        this.addEventListener('enable-add-btn', (e) => {
            const customEvent = e;
            this._addBtnEnabled = customEvent.detail.enabled;
        });
        this.addEventListener('enable-validate-btn', (e) => {
            const customEvent = e;
            this._validateBtnEnabled = customEvent.detail.enabled;
        });
        this.addEventListener('enable-auto-close', (e) => {
            const customEvent = e;
            this.autoClose = customEvent.detail.autoClose;
        });
        // Set the width of the modal container if a width is specified
        const container = this.shadowRoot?.querySelector('.slds-modal__container');
        if (container && this.style.width && this.style.width.length > 0) {
            container.style.width = this.style.width;
        }
    }
    getTabIndex() {
        switch (this.variant) {
            case ModalComponent_1.ALERT:
                return '0';
            case ModalComponent_1.SUCCESS:
                return '0';
            default:
                return '-1';
        }
        this.addEventListener;
    }
    getModalClass() {
        switch (this.variant) {
            case ModalComponent_1.ALERT:
                return 'slds-modal_prompt';
            case ModalComponent_1.SUCCESS:
                return '';
            default:
                return '';
        }
    }
    getHeaderClass() {
        switch (this.variant) {
            case ModalComponent_1.ALERT:
                return 'slds-theme_error slds-theme_alert-texture';
            case ModalComponent_1.SUCCESS:
                return 'slds-theme_success slds-theme_success-texture';
            default:
                return '';
        }
    }
    getRole() {
        switch (this.variant) {
            case ModalComponent_1.ALERT:
                return 'alertdialog';
            case ModalComponent_1.SUCCESS:
                return 'dialog';
            default:
                return 'dialog';
        }
    }
    getSlottedFormValues() {
        const assignedElements = this.slotElement.assignedElements();
        const form = assignedElements.find((element) => element.querySelector('.slds-form'));
        if (form) {
            const formElements = form.querySelectorAll('input, select, textarea');
            return Array.from(formElements).map((element) => {
                if (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement || element instanceof HTMLSelectElement) {
                    return element.value;
                }
                return null;
            });
        }
        else {
            return [];
        }
    }
    render() {
        if (!this.isOpen) {
            return nothing;
        }
        return html `
      <section
        tabindex="${this.getTabIndex()}"
        id="modal-${this.uniqueId}"
        class="slds-modal slds-fade-in-open ${this.getModalClass()}"
        role="${this.getRole()}"
        aria-labelledby="modal-heading"
        aria-modal="true"
      >
        <div class="slds-modal__container">
          <div class="slds-modal__header ${this.getHeaderClass()}">
            ${this.variant !== 'default'
            ? ''
            : html ` <button
                  class="slds-button slds-button_icon slds-modal__close slds-button_icon-inverse"
                  title="Close"
                  @click=${this.handleCancelAndClose}
                >
                  ${Icon.getSVGIconTag({
                icon: 'close',
                sprite: 'utility',
                classes: ['slds-button__icon_large', 'slds-button__icon'],
            })}
                  <span class="slds-assistive-text">Close</span>
                </button>`}
            <h1
              id="modal-heading"
              class="slds-modal__title slds-hyphenate ${this.modalTitle.length <= 0 ? 'slds-hidden' : ''}"
              tabindex="${this.getTabIndex}"
            >
              ${this.modalTitle}
            </h1>
          </div>
          <div class="slds-modal__content slds-p-around_medium" id="modal-content">
            <slot></slot>
          </div>
          <div class="slds-modal__footer">
            ${this.showCancelBtn
            ? html `<ggo-button variant="cancel" label="${Translate.get('btn_cancel')}" @onclick=${this.handleCancelAndClose}></ggo-button>`
            : nothing}
            ${this.showValidateBtn
            ? html `<ggo-button .disabled="${!this._validateBtnEnabled}" variant="validate" label="${Translate.get('btn_validate')}" @onclick=${this.handleSave}></button>`
            : nothing}
            ${this.showAddBtn
            ? html `<ggo-button .disabled="${!this._addBtnEnabled}" variant="validate" label="${Translate.get('btn_add')}" @onclick=${this.handleSave}></button>`
            : nothing}
            ${this.showCloseBtn
            ? html `<ggo-button variant="cancel" label="${Translate.get('btn_close')}" @onclick=${this.handleCancelAndClose}></ggo-button>`
            : nothing}
          </div>
        </div>
      </section>
      <div id="backdrop-${this.uniqueId}" class="slds-backdrop slds-backdrop_open" role="presentation"></div>
    `;
    }
    handleCancelAndClose() {
        this.close();
        const cancelEvent = new CustomEvent('cancel');
        this.dispatchEvent(cancelEvent);
    }
    handleSave() {
        this.close();
        const saveEvent = new CustomEvent('save', { detail: this.getSlottedFormValues() });
        this.dispatchEvent(saveEvent);
    }
    open() {
        this.isOpen = true;
        // Ajoute l'écouteur quand la modal s'ouvre
        setTimeout(() => {
            if (this.autoClose) {
                window.addEventListener('mousedown', this._onOutsideClick, true);
            }
        });
        console.log('open');
        return this;
    }
    close(opts = { destroy: true }) {
        const modal = this.shadowRoot?.querySelector('#modal-' + this.uniqueId);
        const backdrop = this.shadowRoot?.querySelector('#backdrop-' + this.uniqueId);
        if (modal)
            modal.classList.add('fade-out');
        if (backdrop)
            backdrop.classList.add('fade-out');
        // Attend la fin de la transition avant de retirer la modal
        setTimeout(() => {
            this.isOpen = false;
            window.removeEventListener('mousedown', this._onOutsideClick, true);
            if (opts?.destroy) {
                this.remove();
            }
            console.log('close');
        }, 300); // 300ms = durée du transition CSS
        return this;
    }
};
__decorate([
    property({ type: Boolean })
], ModalComponent.prototype, "isOpen", void 0);
__decorate([
    property({ type: Boolean })
], ModalComponent.prototype, "showValidateBtn", void 0);
__decorate([
    property({ type: Boolean })
], ModalComponent.prototype, "showAddBtn", void 0);
__decorate([
    property({ type: Boolean })
], ModalComponent.prototype, "showCancelBtn", void 0);
__decorate([
    property({ type: Boolean })
], ModalComponent.prototype, "showCloseBtn", void 0);
__decorate([
    property({ type: Boolean })
], ModalComponent.prototype, "autoClose", void 0);
__decorate([
    property({ type: String })
], ModalComponent.prototype, "variant", void 0);
__decorate([
    property({ type: String })
], ModalComponent.prototype, "modalTitle", void 0);
__decorate([
    state()
], ModalComponent.prototype, "_addBtnEnabled", void 0);
__decorate([
    state()
], ModalComponent.prototype, "_validateBtnEnabled", void 0);
__decorate([
    query('slot')
], ModalComponent.prototype, "slotElement", void 0);
ModalComponent = ModalComponent_1 = __decorate([
    customElement('ggo-modal')
], ModalComponent);
export { ModalComponent };
